import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { API_FETCH, API_POST } from "../General/Utility";
import { Select_posReturnProduct } from "../features/Transactionstates";

function ProductReturn(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _Common = useSelector((store) => store.Transstates.Common);
  const _HT = useSelector((store) => store.Transstates.Header);
  const _DT = useSelector((state) => state.Transstates.Data);

  const [arrEntPermission, setarrEntPermission] = useState([]);
  const [arrEntReturn, setarrEntReturn] = useState([]);
  const [Customer, setCustomer] = useState({});
  const tableRef = useRef(null);

  useEffect(() => {
    Load_PosReturn(props.VouchId);
    short_cut_keypress();
  }, []);

  const Load_PosReturn = async (Vouchid) => {
    try {
      await Pre_Loading(dispatch, true);
      const res = await API_FETCH(
        `POS/View_ReturnProduct/${Vouchid}/${_AuthParems.DB}`,
        dispatch
      );
      if (res) {
        setCustomer(res.EntReturn.entParty[0]);
        setarrEntPermission(res.TransPer);
        let EntRetPro = res.EntReturn.entProduct;
        if (_DT.arrEntDT.length > 0) {
          let NotExistsItem = [];
          for (var i = 0; i < EntRetPro.length; i++) {
            for (let j = 0; j < _DT.arrEntDT.length; j++) {
              if (
                _DT.arrEntDT[j].proId !== EntRetPro[i].proId &&
                _DT.arrEntDT[j].vouchId !== EntRetPro[i].vouchId &&
                _DT.arrEntDT[j].qty !== EntRetPro[i].qty
              ) {
                NotExistsItem.push(EntRetPro[i]);
              }
            }
          }
          setarrEntReturn(NotExistsItem);
        } else {
          setarrEntReturn(EntRetPro);
        }
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };
  const short_cut_keypress = () => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        props.Close();
      }
    });
  };
  const ConvertClick = async () => {
    try {
      await Pre_Loading(dispatch, true);
      let EntRetPro = arrEntReturn.filter((DT) => DT.isChecked === true);
      const res = await API_POST(
        `Transaction/View_ReturnProducts`,
        {
          bUpdateStatus: false,
          iRowIndex: 0,
          iScrId: _Common.iScrId,
          iTaxRelId: _HT.iTaxRelId,
          iPartyId: Customer.iCustId,
          iTaxCalcOnId: _Common.iTaxCalcOnId,
          objBaseTransDT: _DT.arrEntDT,
          objEntAddLess: _DT.arrEntAL,
          objReturnModel: EntRetPro,
          strDBName: _AuthParems.DB,
          iBranchId: Number(_AuthParems.Branch),
        },
        dispatch
      );
      if (res) {
        res.Customer = Customer;
        await dispatch(Select_posReturnProduct(res));
        await props.View_Return(arrEntPermission);
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };
  const NumtoDecimal = (num) => {
    return Number(num).toFixed(2);
  };
  const converttodecimal = (value) => {
    return Number(value).toFixed(2);
  };
  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>POS Return</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={props.Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body p-0">
          <div className="pos-view p-0">
            <div className="pos-itemlist">
              <table className="product-table" ref={tableRef}>
                <thead>
                  <tr>
                    <th style={{ maxWidth: "50px" }}>Select</th>
                    <th>Vouch No</th>
                    <th>Vouch Date</th>
                    <th>Product Name</th>
                    <th>Qty</th>
                    <th>Net Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {arrEntReturn.map((product, trIndex) => (
                    <tr key={trIndex}>
                      <td style={{ maxWidth: "50px", textAlign: "center" }}>
                        <input
                          type="checkbox"
                          value={product.isChecked}
                          onChange={(e) => {
                            let Entpro = arrEntReturn;
                            Entpro[trIndex].isChecked = !product.isChecked;
                            setarrEntReturn(Entpro);
                          }}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>{product.vouchNo}</td>
                      <td style={{ textAlign: "center" }}>
                        {product.vouchDate}
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {product.proName}
                        <sub style={{ marginLeft: "10px" }}>
                          {product.attValues.replace(new RegExp("/", "g"), "-")}
                        </sub>
                        <br />
                        <span>
                          GST - {NumtoDecimal(product.taxPer)} % | Unit :
                          {product.unitName}
                        </span>
                      </td>
                      <td style={{ textAlign: "center" }}>{product.qty}</td>
                      <td style={{ textAlign: "right" }}>
                        {converttodecimal(product.totalVal)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button className="btn-fabgreen" onClick={(e) => ConvertClick()}>
              Convert&nbsp;<i className="bx bx-transfer"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductReturn;
